import React from 'react';
import { Redirect } from "react-router-dom";

import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import Matrix from 'scripts/Matrix'
import { Button } from '@material-ui/core';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';

// import style from 'style/profile.css'
import axios from 'axios';
import utils from '../../Utils'
import ConsultCategoryItem from './ConsultCategoryItem';
import queryString from 'query-string'
import style from 'style/consult/NewConsult.css'
import store from '../../scripts/store';





const STEP_CATEGORY = 1
const STEP_QUIZ = 0
const STEP_QUESTION = 2
const STEP_PURCHASE = 3
const DESC_QUESTION = 'وارد کردن فرم پرسش از دکتر ملک زاده'
class NewConsult extends React.Component {

  constructor(props) {
    super(props)
    const consultRequestId = this.props.location.state && this.props.location.state.consultId

    this.state = {
      loading: false,
      redirect: '',
      categories: [],
      step: this.props.location.state ? STEP_PURCHASE : STEP_QUIZ,
      headerDesc: DESC_QUESTION,
      sendLoading: false,
      consultCategory: {},
      wallet: {},

      data: {
        question: '', // todo: empty this field
        doctorId: 172,
        callback: utils.urls.askQuestionCallbackURL,
        age: '',
        height: '',
        weight: '',
        drugs: '',
        disease: '',
        lastVisit: ''
      },
    }
  }

  apiGetCategory = async (id) => {
    this.setState({ loading: true })
    let result = await axios.get(utils.urls.consultCategoryURL(id)).catch((e) => {
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return

    let { success, consultCategory } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ consultCategory })
  }
  apiGetAllConsultCategory = async () => {
    this.setState({ loading: true })
    let result = await axios.get(utils.urls.consultCategories).catch((e) => {
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, consultCategories } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ categories: consultCategories })
  }
  async componentDidMount() {
    if (this.props.location.state && this.props.location.state.consultRequest) this.justCompletePayment()
    if (this.state.data.ConsultRequestId) {
      this.setState({
        headerDesc: DESC_QUESTION,
        step: STEP_QUESTION,
      })
      return
    }
    // this.apiGetAllConsultCategory()
    await this.apiGetCategory(1)
    const wallet = await store.getWallet()
    this.setState({ wallet })
  }

  justCompletePayment = () => {
    const { consultRequest: { question, price, ConsultRequestPatientInfo: { age, weight, height, disease, drugs, lastVisit } } } = this.props.location.state.consultRequest

    this.setState({
      data: { ...this.state.data, question, age, disease, drugs, height, lastVisit, weight },
      consultCategory: { price },
      consultRequestId: this.props.location.state.consultRequest.consultRequest.id,
    });
  }

  onCategoryClicked = (categoryId) => {
    this.setState({
      headerDesc: DESC_QUESTION,
      step: STEP_QUESTION,
      data: { ...this.state.data, ConsultCategoryId: categoryId }
    })
  }

  onTextInputHandle = (event) => {
    this.setState({ data: { ...this.state.data, question: event.target.value } })
  }

  apiSendQuestion = async () => {
    this.setState({ sendLoading: true })
    let url = this.state.data.ConsultRequestId ? utils.urls.consultAskQuestionWithQuiz : utils.urls.consultNewAskQuestion
    let result = await axios.post(url, { ...this.state.data }, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ sendLoading: false })

    if (!result) return

    let { success, chargeWalletResult, consultRequest } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    if (chargeWalletResult) {
        const params = Object.keys(chargeWalletResult.params)
        const values = Object.values(chargeWalletResult.params)

        document.getElementById('atipay').innerHTML = ''

        for(let i = 0; i<params.length; i++) {
            document.getElementById('atipay').innerHTML += `<input type="hidden" value="${values[i]}" name="${params[i]}"/>`
        }

        document.getElementById('atipay').submit()

    } else
      this.setState({ redirect: { pathname: '/chats' } })
  }

  formatMoney = (price) => {
    return (parseInt(price)).toLocaleString("fa-IR", { minimumFractionDigits: 0 })
  }

  calcTotal = () => {
    const fee = 100000 - this.state.wallet.credit
    if (fee >= 0) return this.formatMoney(fee)
    if (fee < 0) return 0
  }

  onTextInputHandle2 = (event, key) => {
    let st = {}
    st[key] = event.target.value
    let newd = { ...this.state.data, ...st }
    this.setState({ data: { ...newd } })

  }
  gotoPurchase = () => {
    if (this.state.data.question && this.state.data.question.length > 60)
      return this.setState({ step: STEP_PURCHASE })
    this.SnackBar.openSnackbar('متن سوال بیش از 60 حرف باشد')
  }
  gotoQuestion = () => {
    if (!this.state.data.age || !this.state.data.weight || !this.state.data.height || !this.state.data.lastVisit || !this.state.data.drugs)
      return this.SnackBar.openSnackbar('همه موارد را کامل نمایید')

    return this.setState({ step: STEP_QUESTION })
  }

  onBack = () => {
    if (this.state.step === STEP_QUESTION)
      return this.setState({ step: STEP_QUIZ })
    if (this.state.step === STEP_PURCHASE)
      return this.setState({ step: STEP_QUESTION })
    this.setState({ redirect: '/chats' })
  }


  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }
    return (
      <React.Fragment>
        <Header title="درخواست مشاوره" showBackButton={true} desc={this.state.headerDesc} onBack={this.onBack}></Header>
        <div class="page-root" >
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>

          {this.state.step === STEP_CATEGORY &&
            <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
              <h3>ابتدا نوع مشاوره را مشخص کنید</h3>
              {!this.state.loading && this.state.categories.map(category =>
                <ConsultCategoryItem key={category.id} category={category} onCategoryClicked={() => this.onCategoryClicked(category.id)}></ConsultCategoryItem>
              )}
            </div>
          }
          {this.state.step === STEP_QUIZ &&
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <div style={{ flexGrow: 1, overflowY: 'auto', paddingRight: '10px', paddingLeft: '10px' }}>
                <h3>سولات زیر را پاسخ دهید</h3>
                <div class='row section'>
                  <div class='age cell-v'>
                    <div>سن شما</div>
                    <input type='number' pattern="\d*" value={this.state.data.age} placeholder='45' onChange={(e) => this.onTextInputHandle2(e, 'age')}></input>
                  </div>
                  <div class='height cell-v'>
                    <div>قد شما (CM)</div>
                    <input type='number' pattern="\d*" value={this.state.data.height} placeholder='180' onChange={(e) => this.onTextInputHandle2(e, 'height')}></input>
                  </div>
                  <div class='weight cell-v'>
                    <div>وزن شما (KG)</div>
                    <input type='number' pattern="\d*" value={this.state.data.weight} placeholder='75' onChange={(e) => this.onTextInputHandle2(e, 'weight')}></input>
                  </div>
                </div>
                <div class='lastVisit section'>
                  <div class="label">تاریخ وشرح آخرین مراجعه</div>
                  <textarea rows="4" value={this.state.data.lastVisit} class="textarea" placeholder="1 فروردین 98 - درد شدید معده " onChange={(e) => this.onTextInputHandle2(e, 'lastVisit')} style={{ width: '100%' }} />
                </div>
                <div class='drugs section'>
                  <div class="label">داروهایی که در حال حاضر استفاده می کنید</div>
                  <textarea rows="4" class="textarea" value={this.state.data.drugs} placeholder="پنتاپرازول 20 میلی گرم" onChange={(e) => this.onTextInputHandle2(e, 'drugs')} style={{ width: '100%' }} />
                </div>
                <div class='drugs section'>
                  <div class="label">اگر نام بیماری خود را میدانید ذکر نمایید</div>
                  <textarea rows="1" value={this.state.data.disease} class="textarea" placeholder="رفلاکس" onChange={(e) => this.onTextInputHandle2(e, 'disease')} style={{ width: '100%' }} />
                </div>
              </div>
              <div onClick={this.gotoQuestion} style={{ textAlign: 'center', padding: '15px 0', background: '#0096de', color: '#fff' }}>
                ثبت و ادامه
              </div>

            </div>
          }

          {this.state.step === STEP_QUESTION &&
            <>
              <div style={{ flexGrow: 1, paddingRight: '10px', paddingLeft: '10px' }}>
                <h3>از پزشک چه سوالی دارید؟</h3>
                <span style={{ fontSize: '12px', marginTop: '-10px', display: 'block' }}>لطفا سوال خود را به صورت کامل در بخش زیر شرح دهید</span>
                <textarea rows="4" class="chatInput" placeholder="شرح حال ..." onChange={this.onTextInputHandle} ref='textInput'
                  value={this.state.data.question}
                  style={{ resize: 'none', backgroundColor: 'rgb(255, 255, 255)', border: 'none', direction: 'rtl', outline: 'none', overflowX: 'hidden', fontSize: '16px', padding: '8px', width: '100%', borderRadius: '8px' }}
                />
                <div class='char'>تعداد حرف پرسش {parseInt(this.state.data.question.length).toLocaleString("fa-IR", { useGrouping: false })}</div>
              </div>

              {this.state.sendLoading && <Loading></Loading>}
              <div onClick={this.gotoPurchase} style={{ textAlign: 'center', padding: '15px 0', background: '#0096de', color: '#fff' }}>
                ثبت و ادامه
              </div>
            </>
          }
          {this.state.step === STEP_PURCHASE &&
            <>
              <div class='purchase'>
                <img src='/images/payment.svg' alt="مشاوره آنلاین پزشکی با بهترین دکترها" class='icon-image purchase-icon' />

                <span>پزشک در کوتاهترین زمان پاسخگوی شما خواهد بود</span>
                <div class='card'>
                  <div class='card-title'>
                    <div class="card-indicator"></div>
                اطلاعات پرداخت
              </div>
                  <div class='row'>
                    <span>مشاوره با پزشک</span>
                    <div class='dot'></div>
                    <span class='price'>{this.formatMoney(100000)} تومان</span>
                  </div>
                  {/* <div class='row'>
                  <span>مشاوره با پزشک</span>
                  <div class='dot'></div>
                  <span class='price'>20.000 تومان</span>
                </div> */}
                  {/* <div class='row'>
                  <span>تخفیف</span>
                  <div class='dot'></div>
                  <span class='price'>3.000 تومان</span>
                </div> */}
                  <div class='row'>
                    <span>کیف پول</span>
                    <div class='dot'></div>
                    <span class='price'>{this.formatMoney(this.state.wallet.credit)} تومان</span>
                  </div>
                  <div class='row total-credit'>
                    <span>مبلغ قابل پرداخت</span>
                    <div class='dot'></div>
                    <span class='price'>{this.calcTotal()} تومان</span>
                  </div>
                </div>
                <div>
                  <Button onClick={() => { this.setState({ step: STEP_QUESTION }) }} variant="outlined" style={{ borderRadius: '23px', marginBottom: '10px' }}>
                    تغییر متن مشاوره
                <EditTwoToneIcon fontSize="small" />
                  </Button>
                </div>
              </div>
              <div class='purchase-btn button' style={{ marginBottom: 0 }} onClick={this.apiSendQuestion}> پرداخت و ثبت نهایی</div>
              <form name="myForm" id="atipay" action="https://mipg.atipay.net/v1/redirect-to-gateway" method="POST"></form>
            </>
          }

          {this.state.loading && <div class="Loading"><Loading /></div>}
        </div>
      </React.Fragment>
    )
  }

}

export default NewConsult
